module.exports = __webpack_public_path__ + "img/career4.9a83f5f8.png";